var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-icon-btn",class:_vm.classes,on:{"click":_vm.onClick}},[_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"u-icon-btn__icon",attrs:{"symbol":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }